import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box, Card, Typography } from '@material-ui/core';
import { PlusIcon, CheckCircleSelected } from 'sharedComponents/Icons';
import { priceFormatterWithCommas } from 'utils/numberFormatter';
import ImageBox from '../ImageBox';

const ProductCard = ({
  classes,
  details,
  userBrand,
  alignCenter,
  className,
  plpProductSelectionForLooks,
  onAddToLookClick,
  pdpEntry,
  hideFunctionalNotForSharingFromSMS,
  showProductMultiSelect,
  isProductCardFromRecommendation,
}) => {
  if (!details) {
    return null;
  }

  const isProductSelected = plpProductSelectionForLooks?.includes(details.productId);

  const renderSelectIcon = () => {
    if (showProductMultiSelect)
      return (
        <div className={cx(classes.iconContainer, isProductSelected && classes.iconContainerSelected)}>
          {!isProductSelected ? (
            <PlusIcon onClick={(e) => onAddToLookClick(e, details.productId)} />
          ) : (
            <CheckCircleSelected onClick={(e) => onAddToLookClick(e, details.productId)} />
          )}
        </div>
      );
  };

  return (
    <Card
      className={cx(classes.productCardContainer, className)}
      id={details.productId}
      raised={false}
      elevation={0}
      data-product-source="preferred"
      data-testid="product-card-details"
    >
      <Link
        className={classes.thumbnailContainer}
        to={{
          pathname: `/products/details/${details.productId}`,
          state: {
            pdpEntry,
            hideFunctionalNotForSharingFromSMS,
            pdpEntryFromProductRecommendation: isProductCardFromRecommendation,
          },
        }}
      >
        <ImageBox
          classes={{ lazyLoadImageContainer: classes.productImageContainer, image: classes.image }}
          src={details.image}
          alt={details.brand}
          title={details.brand}
          name="mainImage"
          userBrand={userBrand}
          withLazyLoad
        >
          {renderSelectIcon()}
        </ImageBox>
      </Link>
      <Link
        to={{
          pathname: `/products/details/${details.productId}`,
          state: { pdpEntry, hideFunctionalNotForSharingFromSMS },
        }}
      >
        <Box
          className={cx(classes.productDescriptionContainer, {
            [classes.centered]: alignCenter,
          })}
        >
          <Typography variant="h2" className={classes.brand} data-testid="product-card-brand">
            {details.brand}
          </Typography>
          <Typography variant="h2" className={classes.title} data-testid="product-card-title">
            {details.title}
          </Typography>
          {details.colorsCount > 1 && (
            <Typography variant="h2" className={classes.brand} data-testid="product-card-color-count">
              {details.colorsCount} colors
            </Typography>
          )}
          <Box>
            <Typography
              className={cx(classes.priceContainer, {
                [classes.strikeThroughPrice]: details.onSalePrice,
              })}
              data-testid="product-card-regular-price"
            >
              ${priceFormatterWithCommas(details.regularPrice)}
            </Typography>
            {details.onSalePrice && (
              <Typography
                className={cx(classes.priceContainer, classes.salePriceContainer)}
                data-testid="product-brand-discount-price"
              >
                ${priceFormatterWithCommas(details.onSalePrice)}
              </Typography>
            )}
          </Box>
          {details.flgBVD && (
            <Typography variant="body2" color="textSecondary" data-testid="product-card-in-stock-flag">
              In Store Only
            </Typography>
          )}
        </Box>
      </Link>
    </Card>
  );
};

ProductCard.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  details: PropTypes.shape({}),
  userBrand: PropTypes.string,
  alignCenter: PropTypes.bool,
  className: PropTypes.string,
  pdpEntry: PropTypes.string,
  isProductCardFromRecommendation: PropTypes.bool,
  showProductMultiSelect: PropTypes.bool,
};

ProductCard.defaultProps = {
  classes: {},
  alignCenter: true,
  details: {},
  isProductCardFromRecommendation: false,
};

export default ProductCard;
